// 开始游戏对话
import { type DialogueData } from "../types"
import { nameMap, emotionMap } from "../config/resources"
import { i18n } from "@/i18n"
import { useGameStore } from "@/store/game"
import { BOARD_SIZE } from "@/services/AIService/goUtils"

// 使用 getArray 方法获取数组类型的 i18n 值
const openingDialogues = i18n.getArray<string>("dialog.openingDialogues")
const guideDialogues = i18n.getArray<string>("dialog.guideDialogues")
const passWithoutSkillDialogue = i18n.getArray<string>(
    "dialog.hardModeEndDialogues"
)
const firstUseSkillDialogues = i18n.getArray<string>(
    "dialog.firstUseSkillDialogues"
)
const randomSkillDialogues = i18n.getArray<string>(
    "dialog.randomSkillDialogues"
)
const shareSuccessDialogues = i18n.getArray<string>(
    "dialog.shareSuccessDialogues"
)
const shareFailedDialogues = i18n.getArray<string>(
    "dialog.shareFailedDialogues"
)

const chooseSkillGuideDialogue = i18n.get("dialog.chooseSkillGuideDialogues")
const useSkillGuideDialogue = i18n.get("dialog.useSkillGuideDialogues")

export const startGameDialogueData: DialogueData[] = [
    {
        text: openingDialogues[0],
        speaker: nameMap.wang,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "right",
    },
    {
        text: openingDialogues[1],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "left",
    },
    {
        text: openingDialogues[2],
        speaker: nameMap.wang,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "right",
        rightEmotion: emotionMap.close,
    },
    {
        text: openingDialogues[3],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "left",
        leftEmotion: emotionMap.smile,
    },
    {
        text: openingDialogues[4],
        speaker: nameMap.wang,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "right",
        rightEmotion: emotionMap.close,
    },
    {
        text: openingDialogues[5],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "left",
    },
    {
        text: openingDialogues[6],
        speaker: nameMap.wang,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "right",
    },
    {
        text: openingDialogues[7],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "left",
        leftEmotion: emotionMap.smile,
    },
    {
        text: openingDialogues[8],
        speaker: nameMap.wang,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "right",
        rightEmotion: "close", // 闭眼
    },
    {
        text: openingDialogues[9],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "left",
        leftEmotion: "smile", // 笑
    },
    {
        text: openingDialogues[10],
        speaker: nameMap.wang,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "right",
        rightEmotion: "sigh",
    },
]

export const startGuideDialogueData: DialogueData[] = [
    {
        text: guideDialogues[0],
        speaker: nameMap.wang,
        leftPortrait: nameMap.wangGuide,
        highlight: "left",
        type: "guide",
    },
    {
        text: guideDialogues[1],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nianGuide,
        highlight: "left",
        leftEmotion: emotionMap.smileGuide,
        type: "guide",
    },
    {
        text: guideDialogues[2],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nianGuide,
        highlight: "left",
        type: "guide",
    },
    {
        text: guideDialogues[3],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nianGuide,
        highlight: "left",
        leftEmotion: emotionMap.smileGuide,
        type: "guide",
        guideKey: "guide1",
        onShow: () => {
            const { setBoard } = useGameStore.getState()
            const board = Array(BOARD_SIZE)
                .fill(null)
                .map(() => Array(BOARD_SIZE).fill(null))
            board[4][3] = "white"
            board[4][4] = "black"
            board[4][5] = "white"
            board[3][4] = "white"
            board[5][4] = "white"
            setBoard(board)
        },
    },
    {
        text: guideDialogues[4],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nianGuide,
        highlight: "left",
        leftEmotion: emotionMap.awkwardGuide,
        type: "guide",
        onShow: () => {
            const { clearBoard } = useGameStore.getState()
            clearBoard()
        },
    },
    {
        text: guideDialogues[5],
        speaker: nameMap.wang,
        leftPortrait: nameMap.wangGuide,
        highlight: "left",
        leftEmotion: emotionMap.closeGuide,
        type: "guide",
    },
    {
        text: guideDialogues[6],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nianGuide,
        highlight: "left",
        leftEmotion: emotionMap.smileGuide,
        type: "guide",
    },
    {
        text: guideDialogues[7],
        speaker: nameMap.wang,
        leftPortrait: nameMap.wangGuide,
        highlight: "left",
        type: "guide",
    },
    {
        text: guideDialogues[8],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nianGuide,
        highlight: "left",
        leftEmotion: emotionMap.smileGuide,
        type: "guide",
    },
]

export const passWithoutSkillDialogueData: DialogueData[] = [
    {
        text: passWithoutSkillDialogue[0],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "left",
        leftEmotion: emotionMap.smile,
    },
    {
        text: passWithoutSkillDialogue[1],
        speaker: nameMap.wang,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "right",
        rightEmotion: emotionMap.close,
    },
    {
        text: passWithoutSkillDialogue[2],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "left",
        leftEmotion: emotionMap.smile,
    },
    {
        text: passWithoutSkillDialogue[3],
        speaker: nameMap.wang,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "right",
    },
    {
        text: passWithoutSkillDialogue[4],
        speaker: nameMap.wang,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "right",
        rightEmotion: emotionMap.close,
    },
    {
        text: passWithoutSkillDialogue[5],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "left",
        leftEmotion: emotionMap.smile,
    },
    {
        text: passWithoutSkillDialogue[6],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "left",
        leftEmotion: emotionMap.smile,
    },
    {
        text: passWithoutSkillDialogue[7],
        speaker: nameMap.wang,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "right",
        rightEmotion: emotionMap.black,
    },
]

export const firstUseSkillDialogueData: DialogueData[] = [
    {
        text: firstUseSkillDialogues[0],
        speaker: nameMap.wang,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "right",
        rightEmotion: emotionMap.sigh,
    },
    {
        text: firstUseSkillDialogues[1],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "left",
        leftEmotion: emotionMap.smile,
    },
    {
        text: firstUseSkillDialogues[2],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "left",
    },
    {
        text: firstUseSkillDialogues[3],
        speaker: nameMap.wang,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "right",
        rightEmotion: emotionMap.black,
    },
]

export const randomSkillDialogueData: DialogueData[] = [
    {
        text: randomSkillDialogues[0],
        speaker: nameMap.wang,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "right",
        rightEmotion: emotionMap.sigh,
    },
    {
        text: randomSkillDialogues[1],
        speaker: nameMap.wang,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "right",
        rightEmotion: emotionMap.close,
    },
    {
        text: randomSkillDialogues[2],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "left",
        rightEmotion: emotionMap.smile,
    },
    {
        text: randomSkillDialogues[3],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "left",
        rightEmotion: emotionMap.smile,
    },
    {
        text: randomSkillDialogues[4],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "left",
        rightEmotion: emotionMap.smile,
    },
]

export const thirdSkillDialogueData: DialogueData[] = [
    {
        text: randomSkillDialogues[5],
        speaker: nameMap.wang,
        leftPortrait: nameMap.nian,
        rightPortrait: nameMap.wang,
        highlight: "right",
    },
]

export const shareSuccessDialogueData: DialogueData[] = [
    {
        text: shareSuccessDialogues[0],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nian,
        highlight: "left",
        leftEmotion: emotionMap.smile,
    },
    {
        text: shareSuccessDialogues[1],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nian,
        highlight: "left",
        leftEmotion: emotionMap.smile,
    },
    {
        text: shareSuccessDialogues[2],
        speaker: nameMap.wang,
        leftPortrait: nameMap.wang,
        highlight: "left",
        rightEmotion: emotionMap.sigh,
    },
    {
        text: shareSuccessDialogues[3],
        speaker: nameMap.wang,
        leftPortrait: nameMap.wang,
        highlight: "left",
        rightEmotion: emotionMap.close,
    },
]

export const shareFailedDialogueData: DialogueData[] = [
    {
        text: shareFailedDialogues[0],
        speaker: nameMap.nian,
        leftPortrait: nameMap.nian,
        highlight: "left",
        leftEmotion: emotionMap.awkward,
    },
    {
        text: shareFailedDialogues[1],
        speaker: nameMap.wang,
        leftPortrait: nameMap.wang,
        highlight: "left",
        rightEmotion: emotionMap.close,
    },
]

export const chooseSkillGuideDialogueData: DialogueData[] = [
    {
        text: chooseSkillGuideDialogue,
        type: "guideSkill",
        guideKey: "guide2",
    },
]

export const useSkillGuideDialogueData: DialogueData[] = [
    {
        text: useSkillGuideDialogue,
        type: "guideSkill",
        guideKey: "guide3",
    },
]
